<div class="cta-card-opt1-container">
  <section
    class="cta-card-opt1"
    [ngClass]="'cta-card-opt1--' + block.data.variant"
    [class.cta-card-opt1--reverse]="block.data.flipped"
    aria-labelledby="cta-card-opt1__panel-heading">
    @if (block.data.hasImage) {
      <div class="cta-card-opt1__panel cta-card-opt1__panel--img">
        <img class="cta-card-opt1__panel-img" [src]="imageUrl" alt="TODO" />
      </div>
    }

    <div
      class="cta-card-opt1__panel cta-card-opt1__panel--content"
      [class.cta-card-opt1__panel--content-no-img]="!block.data.hasImage">
      <h2 class="cta-card-opt1__panel-heading" [innerText]="block.data.heading | translate"></h2>

      <div class="cta-card-opt1__panel-description" [innerHTML]="block.data.description | translate"></div>

      <core-coro-button [button]="block.data.button"></core-coro-button>
    </div>
  </section>
</div>
